import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardProvider {

  constructor(
    private authService: NbAuthService,
    private router: Router
    ) { }

  canActivate() {
    return this.authService.isAuthenticated()
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            this.router.navigate(['/auth/login']);
          }
        }),
      );
  }
}
